// import React from "react";
// import "./Footer.scss";

export default function Footer() {
  return null; // No JSX, no lint issues
}
